import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { InstitutionUserPerfis } from 'models'

interface FormNotificationsInterface {
    input?: InputBuildProps
    select?: SelectBuildProps
    layout: LayoutProps
}

export const formNotifications = (
    perfisOptions: InstitutionUserPerfis[]
): FormNotificationsInterface[] => [
    {
        input: {
            id: 'titulo',
            label: 'Título',
            required: true,
            maxLength: 128
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    },
    {
        input: {
            id: 'dataExpiracao',
            label: 'Data de Expiração',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        select: {
            id: 'perfilId',
            label: 'Acesso',
            options: perfisOptions.map(({ id, perfil }) => ({
                text: perfil,
                value: id
            })),
            isDisable: perfisOptions.length < 1
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'descricao',
            label: 'Descrição',
            required: true,
            maxLength: 500,
            placeholder: 'Descreva a descrição'
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    }
]
